/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateInvoicePaymentDto
 */
export interface CreateUpdateInvoicePaymentDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoicePaymentDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoicePaymentDto
     */
    amount?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateInvoicePaymentDto
     */
    paymentDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoicePaymentDto
     */
    paymentCollectionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoicePaymentDto
     */
    sender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInvoicePaymentDto
     */
    hash?: string | null;
}

/**
 * Check if a given object implements the CreateUpdateInvoicePaymentDto interface.
 */
export function instanceOfCreateUpdateInvoicePaymentDto(value: object): value is CreateUpdateInvoicePaymentDto {
    return true;
}

export function CreateUpdateInvoicePaymentDtoFromJSON(json: any): CreateUpdateInvoicePaymentDto {
    return CreateUpdateInvoicePaymentDtoFromJSONTyped(json, false);
}

export function CreateUpdateInvoicePaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateInvoicePaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'paymentDate': json['paymentDate'] == null ? undefined : (new Date(json['paymentDate'])),
        'paymentCollectionId': json['paymentCollectionId'] == null ? undefined : json['paymentCollectionId'],
        'sender': json['sender'] == null ? undefined : json['sender'],
        'hash': json['hash'] == null ? undefined : json['hash'],
    };
}

export function CreateUpdateInvoicePaymentDtoToJSON(value?: CreateUpdateInvoicePaymentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'title': value['title'],
        'amount': value['amount'],
        'paymentDate': value['paymentDate'] == null ? undefined : ((value['paymentDate'] as any).toISOString()),
        'paymentCollectionId': value['paymentCollectionId'],
        'sender': value['sender'],
        'hash': value['hash'],
    };
}

